export const API_URL = "https://bo.parkplyus.az/api/v1";
export const apiToken = "3GhRJi7Z4uBvTnf2yQPcM5Ys8UeAxLk0WdFVX9vNwQ6zPbKuV";
